<button (click)="goToTop()" [class.is-shown]="isShown">
  <i class="fas fa-chevron-up" [class.is-shown]="isShown"></i>
</button>
